// extracted by mini-css-extract-plugin
export default {"loadingMessage":"loadingMessage-HGjoa","icon":"icon-Qy6nX","message":"message-dsD9x","black":"black-mdgkJ","accent":"accent-gqqzM","default":"default-TnYXW","large":"large-TN_YB"};